<template>
  <div>
    <div class="item">
      <label class="lft">工程名称：</label>
      <label class="cnt">{{ data.enginner_name }}</label>
    </div>
    <div class="item">
      <label class="lft">检测项目：</label>
      <label class="cnt">{{ data.test_item }}</label>
    </div>
    <div class="item">
      <label class="lft">携带设备：</label>
      <div class="cnt" style="width: 100%">
        <el-tag
          closable
          style="margin-right: 10px; margin-bottom: 5px"
          @close="onDeviceDel(item.id)"
          v-for="item in deviceList"
          >{{ item.name }}({{ item.no }})</el-tag
        >
        <el-button :disabled="regState == 0" size="small" @click="scanCode()"
          >扫码添加</el-button
        >
      </div>
    </div>
    <div style="margin-top: 20px">
      <el-button type="primary" style="width: 100%" @click="submitForm()"
        >保存</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "task_add",
  components: {},
  data() {
    return {
      regState: 0, // wx注册状态
      data: {},
      deviceList: [], //绑定的设备列表
    };
  },
  mounted() {
    this.regWxInfo();
  },
  methods: {
    async regWxInfo() {
      var data = await this.$api.request.get("/device/getwxinfo", {
        params: {
          url: location.href,
        },
      });
      wx.config({
        beta: true,
        debug: false,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: ["checkJsApi", "scanQRCode"],
      });
      var that = this;
      wx.ready(function () {
        that.regState = 1;
      });
      wx.error(function (res) {
        alert("参数注册失败");
      });
    },
    scanCode() {
      var that = this;
      wx.scanQRCode({
        desc: "scanQRCode desc",
        needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是条形码（一维码），默认二者都有
        success: function (res) {
          // 回调
          var result = res.resultStr; //当needResult为1时返回处理结果
          that.addDeviceList(result);
        },
        error: function (res) {
          if (res.errMsg.indexOf("function_not_exist") > 0) {
            alert("版本过低请升级");
          }
        },
      });
    },
    async addDeviceList(code) {
      //判定是否已经存在，如果已经存在，则不添加
      if (
        this.deviceList.filter((f) => {
          return f.no == code;
        }).length > 0
      ) {
        this.$api.error("此设备已添加");
        return;
      }
      var dev = await this.$api.request.get("/device/get", {
        params: {
          no: code,
        },
      });
      this.deviceList.push(dev);
    },
    async showInfo(id) {
      this.data = await this.$api.request.get("/task/get", {
        params: {
          id: id,
        },
      });
      this.deviceList = await this.$api.request.get("/task/get_devicelist", {
        params: {
          taskid: id,
        },
      });
    },
    async onDeviceDel(id) {
      //删除某个设备
      for (var i = 0; i < this.deviceList.length; i++) {
        if (this.deviceList[i].id == id) {
          this.deviceList.splice(i, 1);
          break;
        }
      }
    },
    async submitForm() {
      var ids = this.deviceList.map((f) => f.id);
      ids = ids.join(",");
      var data = await this.$api.request.post("/task/save_devicelist", {
        taskid: this.data.id,
        ids: ids,
      });
      this.$api.success("操作成功");
      this.$router.replace("/");
      this.$emit("onSuccess", { id: this.data.id });
    },
  },
};
</script>
<style scoped>
.item {
  display: flex;
  align-items: center;
  min-height: 40px;
}
.item .lft {
  text-align: left;
  min-width: 80px;
}
.item .cnt {
  text-align: left;
}
</style>
